module.exports = __webpack_public_path__ + "3b55a2af848ab9406dfba07d3a9c2bc4.svg";